import script from "./subjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectCard.vue?vue&type=script&setup=true&lang=js"

import "./subjectCard.vue?vue&type=style&index=0&id=0b6438cb&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6438cb"]])

export default __exports__